import React, { Component } from 'react';

const withValidateResponse = WrapperComponent => {
    return class extends Component {
        state = {
            validateResponse: null
        }

        handleError = message => {
            this.setResponse('error', message)
        }

        handleNotice = message => {
            this.setResponse('notice',message)
        }

        handleSuccess = message => {
            this.setResponse('success', message)
        }

        handleDismiss = _ => {
            this.setState({
                validateResponse: null
            })
        }

        setResponse = (type, message) => {
            if (typeof message === 'undefined') {
                throw new Error('Validate message cannot be empty');
            }

            if(typeof type === 'undefined') {
                throw new Error('Validate type cannot be empty');
            }

            const validateResponse = {
                type,
                message
            }
    
            this.setState({
                validateResponse
            })
        } 

        render() {
            return (
                <WrapperComponent
                    {...this.props}
                    validateResponse={this.state.validateResponse}
                    handleError={this.handleError}
                    handleSuccess={this.handleSuccess}
                    handleDismiss={this.handleDismiss}
                    handleNotice={this.handleNotice}
                />
            )
        }
    }
}

export default withValidateResponse;